<template>
  <div>
    <b-form-input
      placeholder="0"
      @input="onChange" :formatter="formatter" class="expand_width input input_wrapper1" v-model="this.value" :class="innerClass" v-bind:style="rightPadding"></b-form-input>
    <span class="unit">{{unit}}</span>
  </div>
</template>

<script>
    export default {
        name: "InputHasUnit",
        props:["unit", "right_padding", "innerClass", "formatter", "value"],
        computed:{
            rightPadding() {
                return {
                    "padding-right": this.right_padding ? `${this.right_padding}px` : "30px"
                }
            }
        },
      data(){
          return {
            data:0,
          }
      },
      methods:{
          onChange(val){
            this.$emit('input', val);
          }
      },
      watch:{
        value(){
          this.data = this.$attrs.value;
        }
      }
    }
</script>

<style scoped lang="scss">
@import "../../assets/css/vars";
  .unit {
    position: absolute;
    right: 15px;
    top: 0.48em;
    font-size: $fs_16;
    font-family: $korean_gd_14_r;
  }
  .input {
    text-align: right;
    color: $black;
    font-size: $fs_17;
    font-family: $korean_gd_14_r;
    padding: 0;
  }
  .input_wrapper1{
    height: 40px;
    border: solid 1px #bebdbd;
    border-radius: 3px;
  }

  ::placeholder{
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/InputHasUnit.vue